// @flow
import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import '../components/icons/FontAwesome';
import ScrollToTop from './ScrollToTop';

import asyncComponent from '../components/core/asyncComponent';

import { Provider } from 'mobx-react';
import userStore from '../modules/user/UserStore';
import authStore from '../modules/auth/AuthStore';
import languageStore from '../modules/lang/LanguageStore';
import resourceStore from '../modules/resource/ResourceStore';
import skillStore from '../modules/skill/SkillStore';
import pathwayStore from '../modules/pathway/PathwayStore';
import playbookStore from '../modules/playbook/PlaybookStore';
import contentStore from '../modules/content/ContentStore';
import adminStore from '../modules/admin/AdminStore';
import notificationStore from '../modules/notification/NotificationStore';

const App = asyncComponent(() => import(/* webpackChunkName: "app" */ './App'));
const Login = asyncComponent(() => import(/* webpackChunkName: "login" */ './Login'));
const Status = asyncComponent(() => import(/* webpackChunkName: "status" */ './Status'));

const Root = () => {
  document.title = 'Marriott L+D - TakeCare GROW';

  return (
    <Provider
      userStore={userStore}
      authStore={authStore}
      resourceStore={resourceStore}
      skillStore={skillStore}
      languageStore={languageStore}
      pathwayStore={pathwayStore}
      playbookStore={playbookStore}
      adminStore={adminStore}
      notificationStore={notificationStore}
      contentStore={contentStore}
    >

      <Router>
        <ScrollToTop>
          <Switch>
            <Route
              path="/status"
              component={Status}
            />
            <Route
              path="/login"
              component={Login}
            />
            <Route
              path="/"
              component={App}
            />
          </Switch>
        </ScrollToTop>
      </Router>
    </Provider>
  );
};

export default Root;



// WEBPACK FOOTER //
// ./src/containers/Root.js